import { handleVersionMismatch } from 'actions/versionSync';
import * as ExchangeActionTypes from 'actiontypes/exchange';
import { VersionMismatch } from 'services/BaseService';

import ExchangeService from 'services/ExchangeService';
import { IFetchExchangeResponse } from 'types/exchange';

const exchangeService = new ExchangeService();

/** ----------------------------------------------------------------------------
 * FETCH EXCHANGE
 -----------------------------------------------------------------------------*/
export default function fetchExchange() {
  return async (dispatch: Function) => {
    dispatch(fetchExchangeRequested());

    try {
      const { data } = await exchangeService.fetchExchange();
      dispatch(fetchExchangeSuccess(data));
      return data;
    } catch (e) {
      if (e instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(e));
      }
      dispatch(fetchExchangeFailure(e));
    }
  };
}

export const fetchExchangeRequested = () => ({ type: ExchangeActionTypes.FETCH_EXCHANGE_REQUESTED });

export function fetchExchangeSuccess(data: IFetchExchangeResponse): { payload: IFetchExchangeResponse, type: string } {
  return {
    type: ExchangeActionTypes.FETCH_EXCHANGE_SUCCESS,
    payload: data,
  };
}

export const fetchExchangeFailure = (error: any) => ({
  type: ExchangeActionTypes.FETCH_EXCHANGE_FAILURE,
  error: true,
  status: error.response && error.response.status,
});